import { stringKeyToTuple, tupleToStringKey } from 'js/lib/stringKeyTuple';

import type { ProductTypes } from 'bundles/university-program-qualification/utils/constants';

type QualificationSurveyProductType = (typeof ProductTypes)[keyof typeof ProductTypes];

/**
 * Builds the `Type~id` key the qualification survey APIs expect, e.g.
 * `Degree~base!~O30WHIkRQJ-vtPeTt_a7xw`.
 *
 * Returns `null` for a missing id rather than `'Degree~'`, which `tupleToStringKey` would
 * produce and which is truthy despite naming no product.
 */
export const buildQualificationSurveyProductId = (
  productType: QualificationSurveyProductType,
  productId?: string | null
): string | null => {
  if (!productId) {
    return null;
  }

  return tupleToStringKey([productType, productId]);
};

/**
 * True when `productId` is a qualification survey key with every tuple component present.
 * Use at the consuming end, where a truthiness check would accept `'Degree~'`.
 */
export const isValidQualificationSurveyProductId = (productId?: string | null): boolean => {
  if (!productId) {
    return false;
  }

  const tuple = stringKeyToTuple(productId);

  return tuple.length >= 2 && tuple.every((component) => component.length > 0);
};

export default buildQualificationSurveyProductId;
